import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const PercentageButtonsPercentIcon = ({ onClick, ...rest }: SvgIconProps & { onClick: () => void }) => {
  return (
    <SvgIcon
      {...rest}
      className="text-t300 ml-2 cursor-pointer stroke-0 transition-all duration-300 hover:brightness-125"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM7.25 9C7.25 8.0335 8.0335 7.25 9 7.25C9.9665 7.25 10.75 8.0335 10.75 9C10.75 9.9665 9.9665 10.75 9 10.75C8.0335 10.75 7.25 9.9665 7.25 9ZM13.25 15C13.25 14.0335 14.0335 13.25 15 13.25C15.9665 13.25 16.75 14.0335 16.75 15C16.75 15.9665 15.9665 16.75 15 16.75C14.0335 16.75 13.25 15.9665 13.25 15ZM16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L16.7071 8.70711Z"
        fill="currentColor"
      ></path>
    </SvgIcon>
  )
}
